var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVertodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.9 102.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    className: "cls-1",
    d: "M34.7,99.71c-13.11.76-24.36-9.25-25.12-22.36-.02-.34-.03-.68-.04-1.02V23.21C10.28,9.96,21.43-.31,34.7.05h32.57c.49-.06.99-.06,1.49,0h.58c1.39,0,2.73.54,3.73,1.51l26.39,25.84c.92.89,1.44,2.12,1.44,3.4v45.55c-.37,13.25-11.38,23.7-24.63,23.39l-41.57-.02ZM73.16,19.12c.14,4.38,3.8,7.83,8.18,7.71h3.12l-11.31-11.07v3.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVertodo);
export default __webpack_public_path__ + "static/media/logo_vertodo.9ec55d80c921f49ec179b371a75709d4.svg";
export { ForwardRef as ReactComponent };